// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Media-module__ui-Media--KBBLG {
  display: inline-flex;
  box-sizing: border-box;
  flex-direction: column;
  flex-shrink: 0;
  align-items: center;
  justify-content: flex-start;
  padding-block: 26px;
}

.Media-module__media--zKgRK {
  position: relative;
  flex: 0 0 auto;
  overflow: hidden;
  border-radius: 2px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.13);
}

.Media-module__media--zKgRK > :only-child,
.Media-module__media--zKgRK > :only-child > img {
  display: block;
  object-fit: cover;
}

.Media-module__title--qR9R2,
.Media-module__description--wpkVD {
  width: 116px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}

.Media-module__title--qR9R2 {
  margin-top: 12px;
  color: #1a1a1a;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.35;
}

.Media-module__description--wpkVD {
  margin-top: 3px;
  color: #77736e;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Media/Media.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;;EAEE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".ui-Media {\n  display: inline-flex;\n  box-sizing: border-box;\n  flex-direction: column;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: flex-start;\n  padding-block: 26px;\n}\n\n.media {\n  position: relative;\n  flex: 0 0 auto;\n  overflow: hidden;\n  border-radius: 2px;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.13);\n}\n\n.media > :only-child,\n.media > :only-child > img {\n  display: block;\n  object-fit: cover;\n}\n\n.title,\n.description {\n  width: 116px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-align: left;\n}\n\n.title {\n  margin-top: 12px;\n  color: #1a1a1a;\n  font-size: 0.875rem;\n  font-weight: 700;\n  line-height: 1.35;\n}\n\n.description {\n  margin-top: 3px;\n  color: #77736e;\n  font-size: 0.75rem;\n  font-weight: 400;\n  line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-Media": `Media-module__ui-Media--KBBLG`,
	"media": `Media-module__media--zKgRK`,
	"title": `Media-module__title--qR9R2`,
	"description": `Media-module__description--wpkVD`
};
export default ___CSS_LOADER_EXPORT___;
